import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';


import "assets/scss/style.scss";
import LandingPage from "pages/LandingPage";
import AboutPage from "pages/AboutPage";
import ProductsPage from "pages/ProductsPage";
import ContactPage from "pages/ContactPage";
import DetailsPage from "pages/DetailsPage";
import Checkout from "pages/Checkout";
import Example from "pages/Example";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route exact path="/about" element={<AboutPage />} />
          <Route exact path="/products" element={<ProductsPage />} />
          <Route exact path="/contact" element={<ContactPage />} />
          <Route exact path="/properties/:id" element={<DetailsPage />} />
          <Route path="/checkout/:id" element={<Checkout />} />
          {/* <Route path="/example" element={<Example />} /> */}
        </Routes>
      </Router>

      <ToastContainer />
    </div>
  );
}

export default App;
